import React from 'react';

import { LoginScreen, StandardLoginScreenContents } from '@paragon/login-tools';
import { Dialog } from '@paragon/popup-state';

export function LogInDialog() {
  // `disableRestoreFocus` so that `autoFocus` works (see https://stackoverflow.com/a/76533962/4046605)
  return (
    <Dialog variant="design" disableRestoreFocus>
      <LoginScreen>
        <StandardLoginScreenContents onLogIn={() => void window.location.reload()} />
      </LoginScreen>
    </Dialog>
  );
}
